import React from 'react';
import { StarRating } from '../product/StarRating';
import { reviews } from '../../data/filters';
export function ReviewsSection() {
  return <section id="reviews" aria-labelledby="reviews-heading" className="scroll-mt-40 bg-surface py-14 lg:py-20" data-id="element-191" data-mp="1fykhy3fkfq2f">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-12 lg:gap-12 lg:px-8" data-id="element-192" data-mp="1ayfyq5n9wh8i">
        <div className="lg:col-span-3" data-id="element-193" data-mp="15zuw5zkjtlgw">
          <h2 id="reviews-heading" className="text-2xl font-bold tracking-tight text-ink sm:text-[28px]" data-id="element-194" data-mp="23ppy6jpf4kd9">
            Wat klanten zeggen
          </h2>
          <div className="mt-5 flex items-end gap-3" data-id="element-195" data-mp="1yoadisr5kfve">
            <span className="text-6xl font-extrabold leading-none tracking-tight text-ink" data-id="element-196" data-mp="1tq8to5lwkciv">4,8</span>
            <span className="pb-1 text-sm text-muted" data-id="element-197" data-mp="1or5nuiy3m29u">/ 5</span>
          </div>
          <div className="mt-3" data-id="element-198" data-mp="icmursq8qwk5">
            <StarRating rating={5} size="md" data-id="element-199" data-mp="idogcr4vv1g4" />
          </div>
          <p className="mt-2 text-sm text-muted" data-id="element-200" data-mp="dcikwlju902w">Op basis van 6.200+ geverifieerde reviews</p>
        </div>

        <ul className="grid gap-8 md:grid-cols-3 md:gap-0 md:divide-x md:divide-line lg:col-span-9" data-id="element-201" data-mp="17q0izwaztnyg">
          {reviews.map(r => <li key={r.name} className="flex flex-col md:px-6 md:first:pl-0" data-id="element-202" data-mp="1collk2dpwjq2">
              <StarRating rating={r.rating} data-id="element-203" data-mp="xrb0c1b9vzh5" />
              <blockquote className="mt-3 flex-1 text-[15px] leading-relaxed text-ink" data-id="element-204" data-mp="xugnhb0ccra8">“{r.text}”</blockquote>
              <p className="mt-4 text-xs font-medium text-muted" data-id="element-205" data-mp="ozsillyohbly">
                <span className="font-semibold text-ink" data-id="element-206" data-mp="oyhj3yc9mq0n">{r.name}</span> · {r.location} · {r.date}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}